import Theme, {useThemeClasses} from '@jetbrains/ring-ui/components/global/theme'
import type {PopupAttrs} from '@jetbrains/ring-ui/components/popup/popup'
import classNames from 'classnames'

import Popup from '../Popup/Popup.lazy'

import styles from './DarkPopup.css'

export default function DarkPopup(props: PopupAttrs) {
  const themeClasses = useThemeClasses(Theme.DARK)

  return (
    <Popup
      {...props}
      top={props.top ?? 0}
      offset={4}
      className={classNames(styles.popup, themeClasses, props?.className)}
    />
  )
}
